import type { IconData } from '@stacksjs/iconify-core'

export const wine: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M39.317 7.095c-.375-2.223-2.182-3.628-4.431-3.788C32.654 3.147 29.184 3 24.001 3s-8.653.148-10.885.307c-2.249.16-4.056 1.565-4.431 3.788C8.327 9.213 8 12.512 8 17.5c0 7.221 4.371 12.26 10.774 13.912c1.03.265 1.78 1.203 1.68 2.261l-.334 3.573c-.113 1.202-.937 2.214-2.07 2.628a78 78 0 0 0-5.265 2.176a1.52 1.52 0 0 0-.886 1.392c0 .86.698 1.558 1.558 1.558h21.084c.86 0 1.558-.698 1.558-1.558c0-.6-.34-1.144-.886-1.392a78 78 0 0 0-5.264-2.176c-1.133-.414-1.958-1.426-2.07-2.628l-.335-3.572c-.1-1.058.651-1.997 1.68-2.262C35.628 29.761 40 24.722 40 17.5c0-4.988-.326-8.287-.684-10.405Z\"/><path d=\"M40 14s-8-.5-16.5-.5S8 14 8 14\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default wine
